export default __webpack_public_path__ + "static/media/premium.9f4a9d27.svg";